import { ArrayDataSource } from '@angular/cdk/collections';
import { NestedTreeControl } from '@angular/cdk/tree';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
} from '@angular/core';
import { menuAccordian } from '@x/common/animations/animations';
import { MenuNode } from '@x/ecommerce-shop/app/core/menu/services/menu.service';
import { IShopConfig, SHOP_CONFIG } from '@x/ecommerce-shop/config/shop.config';

@Component({
  selector: 'x-main-menu-tree',
  templateUrl: './main-menu-tree.component.html',
  styleUrls: ['./main-menu-tree.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [menuAccordian],
  host: { class: 'x-main-menu-tree' },
})
export class MainMenuTreeComponent {
  _dataSource: ArrayDataSource<MenuNode>;
  _activeNodeAscendants: MenuNode[] = [];

  @Input() set nodes(nodes: MenuNode[] | undefined | null) {
    if (nodes) {
      this._dataSource = new ArrayDataSource<MenuNode>(nodes);
    }
  }

  @Input() depth: number | null = 1;

  @Input() set activeNodeAscendants(nodes: MenuNode[]) {
    if (nodes) {
      this._activeNodeAscendants = [...nodes];
      this.activeNodeAscendants.forEach((node) => {
        this.treeControl.expand(node);
      });
    }
  }

  @Input() set activeNode(node: MenuNode | null) {
    if (node) {
      this.activeNodeAscendants = [...this.activeNodeAscendants, node];
    }
  }

  @Output() nodeSelected = new EventEmitter();

  get dataSource(): ArrayDataSource<MenuNode> {
    return this._dataSource;
  }

  get activeNodeAscendants() {
    return this._activeNodeAscendants;
  }

  treeControl = new NestedTreeControl<MenuNode>((node) => node.children);

  hasChildren = (_: number, node: MenuNode) => {
    const hasChildren = !!node.children && node.children.length > 0;

    if (this.depth) {
      return node.depth <= this.depth && hasChildren;
    }

    return hasChildren;
  };

  collapseNodes(node: MenuNode) {
    if (!this.shopConfig.features.menuTree.nodeAutoClose) return;
    if (!this.treeControl.isExpanded(node)) {
      this.treeControl.collapse(node);
      return;
    }
    if (node.parent) {
      this.treeControl.collapseDescendants(node.parent);
      this.treeControl.expand(node.parent);
    }

    this.treeControl.expand(node);
  }

  isActive(node: MenuNode): boolean {
    return this.activeNodeAscendants.map((node) => node.id).includes(node.id);
  }

  showTaxonsOnMobile(node: MenuNode) {
    return this.shopConfig.features.menuTree.taxonTargetLevel.includes(node.depth);
  }

  constructor(@Inject(SHOP_CONFIG) private shopConfig: IShopConfig) {}
}
